import axios from "./HttpRequestCustomerApp"

  function  getStoreBySKU(sku){
        return axios.get('/web/store/filter/all/v2?skus='+sku);
  }

  function  getStoreBySKUandQuantity(lat, lng,provinceCode, districtCode, wardCode, sku, quantity){
    var _param ='';
        if (lat !== 0){
          _param = _param +"&lat="+lat;
        }
        if(lng !== 0){
          _param = _param +"&lng="+lng;
        }
        if(provinceCode !== ''){
            _param = _param + "&provinceCode="+provinceCode;
        }
        if(districtCode !== ''){
            _param = _param + "&districtCode="+districtCode;
        }
        if(wardCode !== ''){
            _param = _param + "&wardCode="+wardCode;
        }
        
      return axios.get('/web/store/filter/all/v2?skus='+sku+'&quantity='+quantity+_param);
  }

  function  getStoreByLatLng(lat, lng, provinceCode, districtCode){
      return axios.get('/web/store/filter/all/v2?lat='+lat+'&lng='+lng+'&macroregionCode=&regionCode=&provinceCode='+provinceCode+'&districtCode='+districtCode+'&wardCode=');
  }
  function  getStoreByLatLng2(lat, lng, provinceCode, districtCode,wardCode){
    return axios.get('/web/store/filter/all/v2?lat='+lat+'&lng='+lng+'&macroregionCode=&regionCode=&provinceCode='+provinceCode+'&districtCode='+districtCode+'&wardCode='+wardCode);
}
  function  getAllStore(){
    return axios.get('/web/store/filter/all/v2');
  }

  export {getStoreBySKU, getAllStore, getStoreBySKUandQuantity,getStoreByLatLng, getStoreByLatLng2}